import React from 'react';
import { EmptyBlock } from '../../elements/EmptyBlock';

// export const SearchEmpty = ({ minHeight }: { minHeight?: number | string }) => {
//     return <Flexer grow flex="row" center borderRadius="1" background={Colors.borderLight} minHeight={minHeight} gap="2">
//         <Icon color={Colors.textLight} size="3" src="deqo://icons/hero/search" />
//         <Title size="2xl" color={Colors.textLight} flush>{'Sorry, we couldn\'t find any matches for your search!'}</Title>
//     </Flexer>;
// };

export const SearchEmpty = () => {
    return <EmptyBlock
        title={'Sorry, we couldn\'t find any matches for your search!'}
        subtitle="Try searching for something else."
    />;
};
